var __jsx = React.createElement;
// context/TrackingWizardContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
var TrackingReturnWizardContext = /*#__PURE__*/createContext(undefined);
export var TrackingReturnWizardProvider = function TrackingReturnWizardProvider(_ref) {
  var children = _ref.children,
    orderDataInSession = _ref.orderDataInSession;
  var _useState = useState("confirm"),
    currentStep = _useState[0],
    setCurrentStep = _useState[1];
  var _useState2 = useState({
      order_id: null,
      order_uuid: null,
      order_type: null,
      isFinance: null,
      city_id: null
    }),
    orderData = _useState2[0],
    setOrderData = _useState2[1];
  useEffect(function () {
    setOrderData({
      order_id: orderDataInSession.order_id || null,
      order_uuid: orderDataInSession.order_uuid || null,
      order_type: orderDataInSession.order_type || null,
      isFinance: orderDataInSession.isFinance || null,
      city_id: orderDataInSession.city_id || null
    });
  }, [orderDataInSession.order_id, orderDataInSession.order_uuid, orderDataInSession.order_type, orderDataInSession.isFinance]);
  var goToStep = function goToStep(step) {
    return setCurrentStep(step);
  };
  return /*#__PURE__*/React.createElement(TrackingReturnWizardContext.Provider, {
    value: {
      currentStep: currentStep,
      goToStep: goToStep,
      orderData: orderData,
      setOrderData: setOrderData
    }
  }, children);
};
export var useTrackingReturnWizard = function useTrackingReturnWizard() {
  var context = useContext(TrackingReturnWizardContext);
  if (!context) {
    throw new Error('useTrackingWizard must be used within a TrackingWizardProvider');
  }
  return context;
};